import StatsCard from "../../../components/stats-card";

export default function TotalBranchesCard({
  styles,
  branchesDisplay,
  branchesError,
  branchListError,
  onOpen,
}) {
  return (
    <StatsCard
      title="Total Branches"
      value={branchesDisplay}
      icon="monitor"
      onClick={onOpen}
    >
      <div className={styles.cardHintRow}>
        <span className={styles.cardHintText}>Click to view branch names</span>
      </div>

      {branchesError && (
        <p className="text-red-500 text-xs mt-1">{branchesError}</p>
      )}
      {branchListError && (
        <p className="text-red-500 text-xs mt-1">{branchListError}</p>
      )}
    </StatsCard>
  );
}
